import ApiService from '@services/api.service'
import TimeZoneService from '@services/business/time-zone.service'
import StorageService from '@services/storage.service'
import { store } from '@state/store'

const JobService = {
  async refreshJobByJobNumber(jobNumber) {
    // Google Analytics/Tag Manager
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ job: { jobNumber: jobNumber } })   
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    const response = await ApiService.get('/Job/' + jobNumber)
    await TimeZoneService.getTimeZoneInfo(response.data.timezone_no)
    store.updateJobFromApi(response.data)
    StorageService.saveJob(jobNumber)
  },

  async setTechStatusToEnroute(jobNumber) {
    await ApiService.post(`/job/${jobNumber}/employee/enroute`, {
      jobNumber: jobNumber,
    }).catch((err) => {
      throw err
    })

    store.updateTechStatusToEnroute()
  },

  async setTechStatusToOnSite(jobNumber) {
    await ApiService.post(`/job/${jobNumber}/employee/onsite`, {
      jobNumber: jobNumber,
    }).catch((err) => {
      console.error(err)
      throw err
    })

    store.updateTechStatusToOnSite()
  },

  async getCodesForJobCompletion() {
    const response = await ApiService.get('/Job/CodesForJobCompletion').catch(
      (err) => {
        throw err
      }
    )

    store.updateJobCodes(response.data)
  },

  async completeJob(completeJobDto) {
    const response = await ApiService.post(
      `/Job/${store.state.currentJob.jobNumber}/Complete`,
      {
        siteNumber: store.state.site.siteNumber,
        jobResId: completeJobDto.resId,
        jobCauseId: completeJobDto.causeId,
        actualProbId: completeJobDto.probId,
        comment: completeJobDto.jobComment,
      }
    ).catch((err) => {
      throw err
    })

    store.markJobComplete()

    return response
  },
}

export default JobService
